/* eslint-disable */
const sdk = {};

function magic(name, options) {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const params = JSON.stringify(options) || '{}';
  if (isiOS) {
    return window.webkit.messageHandlers[name].postMessage(params);
  }
  if (isAndroid) {
    return hsbpro_jscall[name](params);
  }
}

sdk.saveImage = options => {
  return magic('saveImage', options);
};

export default sdk;
